
import { useRoute } from 'vue-router';
import Navbar from '@/components/Navbar.vue';
import Practice from '@/components/Practice.vue';
import PracticeMessageStream from '@/components/PracticeMessageStream.vue';
import { ref } from 'vue';
import { classTitleToWords } from '@/classes';

export default {
  components: { Navbar, Practice, PracticeMessageStream },
  setup() {
    const route = useRoute();

    function randomWord() {
      const words = classTitleToWords[route.name?.toString() ?? ''] ?? [];
      return words[Math.floor(Math.random() * words.length)];
    }

    const word = ref(randomWord());

    const next = () => {
      let newWord = randomWord();
      while (newWord === word.value) {
        newWord = randomWord();
      }

      word.value = newWord;
    };

    return { word, next };
  },
};
